<template>
  <b-overlay :show="show" rounded="md">
    <b-container id="main-container" fluid style>
      <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
        <b-col class="" cols="12">
          <nav-header ref="header"></nav-header>
        </b-col>
      </b-row>

      <b-row
        align-h="center"
        style="width: 100%; margin-top: 60px"
        class="first-div-after-header"
      >
        <b-col cols="12" style="padding-top: 5px" class="pl-0 pr-0 cart-nav">
          <b-row class="pl-0 pr-0 pt-2 pb-4">
            <div class="pl-0">
              <a href="/#/select" class="pr-1">Product Select</a> /
            </div>
            <div v-if="state == 0"><a class="pl-1 pr-1">Cart</a></div>
            <div v-if="state > 0">
              <a href="#" @click="gotostate(0)" class="pl-1 pr-1">Cart</a> /
            </div>

            <div v-if="state == 1">
              <a class="pl-1 pr-1">Shipping </a>
            </div>
            <div v-if="state > 1">
              <a href="#" @click="gotostate(1)" class="pl-1 pr-1">Shipping </a>
              /
            </div>

            <div v-if="state == 2">
              <a class="pl-1 pr-1">Payment </a>
            </div>
            <div v-if="state > 2">
              <a href="#" @click="gotostate(2)" class="pl-1 pr-1">Payment </a>
              /
            </div>

            <div v-if="state == 3"><a class="pl-1 pr-1">Order Summary</a></div>
            <div v-if="state > 3">
              <a href="#" @click="gotostate(3)" class="pl-1 pr-1"
                >Order Summary</a
              >
              /
            </div>
            <div v-if="state == 4"><a class="pl-1 pr-1">支付页面</a></div>
            <div v-if="state > 4">
              <a href="#" @click="gotostate(4)" class="pl-1 pr-1">支付页面</a>
            </div>
          </b-row>

          <b-row>
            <b-col
              style="font-size: 24px; padding-left: 0"
              align-self="center"
              v-if="state == 0"
            >
              Shopping Cart
            </b-col>
            <b-col
              style="font-size: 24px; padding-left: 0"
              align-self="center"
              v-if="state == 1 && getKioskID() == null"
            >
              Shipping Address
            </b-col>
            <b-col
              style="font-size: 24px; padding-left: 0"
              align-self="center"
              v-if="state == 1 && getKioskID() != null"
            >
              Billing Address
            </b-col>
            <b-col
              style="font-size: 24px; padding-left: 0"
              align-self="center"
              v-if="state == 2"
            >
              Payment Information
            </b-col>
            <b-col
              style="font-size: 24px; padding-left: 0"
              align-self="center"
              v-if="state == 3"
            >
              Order Summary
            </b-col>
            <b-col
              style="font-size: 24px; padding-left: 0"
              align-self="center"
              v-if="state == 4"
            >
              支付
            </b-col>
            <b-col
              class="reduced_pl_pr"
              style="text-align: right"
              align-self="center"
              hidden
            >
              <b-row style="text-align: right">
                <b-col class="pr-0">
                  <b style="font-size: 18px" v-if="state == 1 || state == 2"
                    >Subtotal ${{ getdiscountedtotalprice(true, true) }}</b
                  >
                </b-col>
              </b-row>
              <b-row>
                <b-col class="pr-0">
                  <b style="font-size: 18px" v-if="state == 1 || state == 2">
                    Shipping ${{ getdiscountedtotalprice(true, true) }}</b
                  >
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="pl-0 pr-0">
              <hr
                style="width: 100%; border: 0.5px solid #d9dadb; margin-left: 0"
              />
            </b-col>
            <b-col
              cols="12"
              class="pl-0 pr-0 reduced_pl_pr"
              v-if="state == 0 || state == 3"
            >
              <b-row style="min-height: 90px">
                <b-col cols="3" class="hide-when-small"> </b-col>
                <b-col
                  md="7"
                  cols="8"
                  align-self="center"
                  class="reduced_pl_pr"
                >
                  <b-row>
                    <b
                      style="font-size: 24px; font-weight: 600"
                      class="h2-font"
                      >{{ producttitle }}</b
                    >
                  </b-row>
                  <b-row class="pt-2" hidden>
                    <b-col class="pl-0 pr-0">
                      Includes {{ getproductname() }}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  md="2"
                  cols="4"
                  align-self="center"
                  class="reduced_pl_pr h2-font"
                >
                  <b-row
                    v-if="
                      getdiscountedtotalprice(false, false) -
                        getdiscountedtotalprice(true, true) <
                      0.1
                    "
                  >
                    <b-col
                      class="pl-0 pr-0"
                      style="font-size: 24px; text-align: right"
                    >
                      $ {{ getdiscountedtotalprice(true, true) }}
                    </b-col>
                  </b-row>
                  <b-row v-else>
                    <b-col
                      cols="12"
                      class="pl-0 pr-0 reduced_pl_pr h2-font"
                      style="font-size: 24px; text-align: right"
                    >
                      $ {{ getdiscountedtotalprice(true, true) }}
                    </b-col>
                    <b-col
                      cols="12"
                      class="pl-0 pr-0 reduced_pl_pr"
                      style="text-align: right"
                    >
                      <s> $ {{ getdiscountedtotalprice(false, false) }}</s>
                      ($-{{
                        (
                          getdiscountedtotalprice(false, false) -
                          getdiscountedtotalprice(true, true)
                        ).toFixed(2)
                      }})
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3" cols="0"> </b-col>
                <b-col md="9" cols="12" class="reduced_pl_pr pl-0 pr-0">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>
              <b-row
                v-for="(item, index) in getselectedsku()"
                v-bind:key="item.sku.skutitle"
                align-h="between"
              >
                <b-col cols="12" md="3" class="more-bottom-padding-small">
                  <b-img
                    :src="getSwatch(item.sku)"
                    style="height: 120px !important; width: 120px !important"
                    class="swatch_small_single_display_skin_cart"
                    v-if="item.sku.productid == 'prod_0000'"
                    center
                  >
                  </b-img>
                  <b-img
                    :src="getSwatch(item.sku)"
                    style="height: 120px !important; width: 120px !important"
                    class="swatch_small_single_display"
                    v-else
                    center
                  >
                  </b-img>
                </b-col>
                <b-col
                  md="5"
                  cols="7"
                  align-self="center"
                  class="reduced_pl_pr"
                >
                  <b-row class="pb-2">
                    <b style="font-size: 24px" class="h4-font">
                      {{
                        item.sku.productname +
                        " (" +
                        item.sku.attributes.Style +
                        ")"
                      }}</b
                    >
                  </b-row>
                  <b-row> Quantity: {{ item.quantity }} </b-row>
                  <b-row
                    v-if="
                      item.sku.id.includes('sku_activation_') &&
                      item.sku.id.includes('skin_opt')
                    "
                    class="pt-3 hide-when-small"
                    hidden
                  >
                    <b-col
                      style="background-color: #fbd9e5; color: #f06595"
                      class="pt-2 pb-2"
                    >
                      This item charges $2.49/user/mo, starting 14 days after
                      purchase. Cancel any time.
                    </b-col>
                  </b-row>
                  <b-row
                    v-else-if="item.sku.id.includes('sku_activation_')"
                    class="pt-3 hide-when-small"
                    hidden
                  >
                    <b-col
                      style="background-color: #fbd9e5; color: #f06595"
                      class="pt-2 pb-2"
                    >
                      This item charges $1.99/user/mo, starting 14 days after
                      purchase. Cancel any time.
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  md="2"
                  cols="2"
                  align-self="center"
                  style="font-size: 24px; width: 100%"
                  class="reduced_pl_pr"
                  v-if="state != 3"
                >
                  <b-row class="pl-3">
                    <dropdown-menu
                      v-model="opencloselist[index]"
                      style="width: 100%"
                    >
                      <button
                        class="btn product-select-box"
                        style="cursor: pointer; width: 100%"
                      >
                        {{ item.quantity }}
                      </button>
                      <div slot="dropdown">
                        <a
                          class="dropdown-item"
                          @click="clickquantity(item, 1)"
                        >
                          1
                        </a>
                        <a
                          class="dropdown-item"
                          @click="clickquantity(item, 2)"
                        >
                          2
                        </a>
                        <a
                          class="dropdown-item"
                          @click="clickquantity(item, 3)"
                        >
                          3
                        </a>
                        <a
                          class="dropdown-item"
                          @click="clickquantity(item, 4)"
                        >
                          4
                        </a>
                        <a
                          class="dropdown-item"
                          @click="clickquantity(item, 5)"
                        >
                          5
                        </a>
                        <a
                          class="dropdown-item"
                          @click="clickquantity(item, 6)"
                        >
                          6
                        </a>
                        <a
                          class="dropdown-item"
                          @click="clickquantity(item, 7)"
                        >
                          7
                        </a>
                      </div>
                    </dropdown-menu>
                  </b-row>
                </b-col>
                <b-col
                  md="2"
                  cols="3"
                  align-self="center"
                  style="font-size: 24px; text-align: right"
                  class="pr-0 reduced_pl_pr"
                  v-if="state == 0"
                >
                  <b-row style="text-align: right">
                    <b-col style="text-align: right" class="reduced_pl_pr">
                      $
                      {{ ((item.sku.price * item.quantity) / 100).toFixed(2) }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="text-align: right" class="reduced_pl_pr">
                      <a href="#" @click="deletesku(item.sku)">Delete</a>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col
                  cols="4"
                  align-self="center"
                  style="font-size: 24px; text-align: right"
                  class="pr-0"
                  v-if="state == 3"
                >
                  <b-row style="text-align: right">
                    <b-col style="text-align: right" class="reduced_pl_pr">
                      $
                      {{ ((item.sku.price * item.quantity) / 100).toFixed(2) }}
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col style="text-align: right" class="reduced_pl_pr">
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="3" class="hide-when-small"> </b-col>

                <b-col
                  cols="12"
                  v-if="
                    item.sku.id.includes('sku_activation_') &&
                    item.sku.id.includes('skin_opt')
                  "
                  style="background-color: #fbd9e5; color: #f06595"
                  class="mt-2 pt-2 pb-2 hide-when-big"
                  hidden
                >
                  This item charges $2.49/user/mo, starting 14 days after
                  purchase. Cancel any time.
                </b-col>
                <b-col
                  cols="12"
                  v-else-if="item.sku.id.includes('sku_activation_')"
                  style="background-color: #fbd9e5; color: #f06595"
                  class="mt-2 pt-2 pb-2 hide-when-big"
                  hidden
                >
                  This item charges $1.99/user/mo, starting 14 days after
                  purchase. Cancel any time.
                </b-col>

                <b-col md="12" cols="12" class="reduced_pl_pr pl-0 pr-0">
                  <hr
                    style="
                      width: 100%;
                      border: 0.5px solid #d9dadb;
                      margin-left: 0;
                    "
                  />
                </b-col>
              </b-row>
              <b-row v-if="state != 3 && getKioskID() == null">
                <b-col cols="3" class="hide-when-small"> </b-col>
                <b-col
                  md="5"
                  cols="12"
                  align-self="end"
                  style="text-align: left"
                  class="pl-3 pt-2 reduced_pl_pr"
                >
                  <b-row>
                    <b-col
                      class="col-2 reduced_pl_pr pl-0 pr-0"
                      align-self="center"
                    >
                      <b-img
                        src="img/box1.png"
                        style="height: 48px; height: 48px"
                      ></b-img>
                    </b-col>
                    <b-col align-self="center">
                      <b-row style="justify-content: left" class="pt-2">
                        Free US standard shipping for $50 or above. Worldwide
                        Shipping.
                      </b-row>
                      <b-row style="justify-content: left" class="pt-2">
                        Express shipping available if pay by credit card
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row
                class="pl-0 pr-0 reduced_pl_pr"
                v-if="state == 0 && getKioskID() == null"
              >
                <hr
                  style="
                    width: 100%;
                    border: 0.5px solid #d9dadb;
                    margin-left: 0;
                  "
                />
              </b-row>
              <b-row v-if="state == 0" hidden>
                <b-col cols="3" class="hide-when-small"></b-col>
                <b-col cols="4" style="font-size: 20px" class="reduced_pl_pr">
                  Shipping
                </b-col>
                <b-col
                  style="font-size: 20px; text-align: right"
                  class="reduced_pl_pr"
                  >Calculated at checkout</b-col
                >
              </b-row>
              <b-row v-if="state == 0" hidden>
                <b-col cols="3" class="hide-when-small"></b-col>
                <b-col class="reduced_pl_pr pl-0 pr-0">
                  <hr style="width: 100%; border: 0.5px solid #d9dadb" />
                </b-col>
              </b-row>
              <b-row v-if="state == 0">
                <b-col cols="12" class="pl-0 pr-0">
                  <b-row
                    class="pb-2"
                    v-if="
                      getdiscountedtotalprice(false, false) -
                        getdiscountedtotalprice(true, true) >
                      0.1
                    "
                  >
                    <b-col cols="3" class="hide-when-small"></b-col>
                    <b-col
                      cols="7"
                      class="reduced_pl_pr"
                      style="font-size: 20px"
                    >
                      Original price
                    </b-col>
                    <b-col
                      class="reduced_pl_pr"
                      style="text-align: right; font-size: 20px"
                    >
                      <s style="font-size: 20px"
                        >$ {{ getdiscountedtotalprice(false, false) }}</s
                      >
                    </b-col>
                  </b-row>

                  <b-row
                    class="pb-2"
                    v-if="
                      getdiscountedtotalprice(false, false) -
                        getdiscountedtotalprice(true, true) >
                      0.1
                    "
                  >
                    <b-col cols="3" class="hide-when-small"></b-col>
                    <b-col
                      cols="7"
                      class="reduced_pl_pr"
                      style="font-size: 20px"
                    >
                      Discount
                    </b-col>
                    <b-col
                      class="reduced_pl_pr"
                      style="text-align: right; font-size: 20px"
                    >
                      $-{{
                        (
                          getdiscountedtotalprice(false, false) -
                          getdiscountedtotalprice(true, true)
                        ).toFixed(2)
                      }}
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="3" class="hide-when-small"></b-col>
                    <b-col
                      cols="7"
                      class="reduced_pl_pr"
                      style="font-size: 20px"
                    >
                      <b style="font-size: 20px" class="h2-font">Subtotal</b>
                    </b-col>
                    <b-col class="reduced_pl_pr" style="text-align: right">
                      <b style="font-size: 20px" class="h2-font"
                        >$ {{ getdiscountedtotalprice(true, true) }}</b
                      >
                    </b-col>
                  </b-row>
                </b-col>

                <b-col
                  cols="12"
                  class="pt-5 pl-0 pr-0"
                  style="text-align: right; padding-top: 10px"
                >
                  <b-row align-h="end" class="pb-2" v-if="show_pay_in_4">
                    <b-col class="pl-0 pr-0" style="text-align: right">
                      <b style="color: #c84141"
                        >4 payments of ${{
                          (getdiscountedtotalprice(true, true) / 4.0).toFixed(
                            2
                          )
                        }}, </b
                      >interest free with PayPal
                    </b-col>
                  </b-row>
                  <b-row align-h="end" v-if="show_pay_in_4">
                    <b-col class="pl-0 pr-0" style="text-align: right">
                      <div
                        id="paypal_button_container"
                        ref="paypalbutton"
                        style="
                          max-width: 500px;
                          display: inline-block;
                          width: 100%;
                        "
                      ></div>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="12" class="pl-0 pr-0" style="text-align: right">
                  <b-row align-h="end">
                    <b-col
                      class="pl-0 pr-0"
                      style="max-width: 500px !important"
                    >
                      <div
                        id="stripe_button_container"
                        ref="stripe_button_container"
                      ></div>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col
                  cols="12"
                  style="text-align: right; padding-top: 5px"
                  class="reduced_pl_pr pl-0 pr-0"
                >
                  <b-button
                    pill
                    class="full-width blue-button variable-height-paypal"
                    style="border-radius: 4px !important"
                    v-on:click="gotostate(1)"
                  >
                    <span class="">Pay with Credit/Debit Card</span>
                  </b-button>
                </b-col>

                <b-col
                  cols="12"
                  style="
                    text-align: right;
                    padding-top: 15px;
                    padding-bottom: 15px;
                  "
                  class="reduced_pl_pr pl-0 pr-0"
                >
                  <b-button
                    pill
                    class="full-width blue-button-outline variable-height-paypal"
                    style="border-radius: 4px !important"
                    v-on:click="clearCart()"
                  >
                    <span class="">Clear Cart</span>
                  </b-button>
                </b-col>
              </b-row>

              <b-row class="pl-0 pr-0 reduced_pl_pr" v-if="state == 0">
                <hr
                  style="
                    width: 100%;
                    border: 0.5px solid #d9dadb;
                    margin-left: 0;
                  "
                />
              </b-row>
              <b-row v-if="state == 0">
                <b-col class="pl-3 pb-5">
                  If you have any questions making selection, please
                  <a href="/#/contact"> chat with us</a>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row v-if="state == 1">
            <b-form style="width: 100%" @submit="onSubmit">
              <b-col class="pl-0 pr-0">
                <b-row v-if="getKioskID() == null">
                  <b style="font-size: 24px; padding-left: 0px" class="h2-font"
                    >Enter your shipping information</b
                  >
                </b-row>

                <b-row>
                  <b-col lg="8" cols="12" class="pl-0 pr-0">
                    <b-row>
                      <b-col lg="6" cols="12" class="pt-4 pl-0 pr-0">
                        <b-row>
                          <b-col
                            class="pl-0 city-state-country"
                            style="padding-bottom: 0"
                          >
                            <b-form-group>
                              <b-form-select
                                v-model="form.country"
                                type="text"
                                :options="getCountryOptions()"
                                required
                                @change="changecountry()"
                                autocomplete="shipping country"
                                name="country"
                                :class="needAdditionalPadding(form.country)"
                                class="select-special"
                              ></b-form-select>

                              <span
                                class="innerlabel reduced_pl_pr"
                                v-if="form.country"
                                >Country</span
                              >
                            </b-form-group>
                            <b-form-invalid-feedback
                              id="form-input-country"
                              class="pl-3 pt-1"
                            >
                              Country cannot be empty
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="pt-3 pb-2" align-h="between">
                      <b-col style="max-width: 48%" class="pl-0 pr-0">
                        <b-form-input
                          v-model="form.fname"
                          placeholder="First Name (*)"
                          id="form-input-fname"
                          type="text"
                          :state="isEmptyString(form.fname)"
                          :class="needAdditionalPadding(form.fname)"
                        ></b-form-input>
                        <span class="innerlabel" v-if="form.fname"
                          >First Name</span
                        >
                        <b-form-invalid-feedback
                          id="form-input-fname"
                          class="pl-3 pt-1"
                        >
                          First name cannot be empty
                        </b-form-invalid-feedback>
                      </b-col>

                      <b-col style="max-width: 48%" class="pl-0 pr-0">
                        <b-form-input
                          v-model="form.lname"
                          placeholder="Last Name (*)"
                          id="form-input-lname"
                          type="text"
                          :state="isEmptyString(form.lname)"
                          :class="needAdditionalPadding(form.lname)"
                        ></b-form-input>
                        <span class="innerlabel" v-if="form.lname"
                          >Last Name</span
                        >
                        <b-form-invalid-feedback
                          id="form-input-lname"
                          class="pl-3 pt-1"
                        >
                          Last name cannot be empty
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>

                    <b-row class="pt-3 pb-2">
                      <b-col cols="12" class="pl-0 pr-0">
                        <b-form-input
                          v-model="form.address1"
                          placeholder="Street Address 1 (*)"
                          autocomplete="shipping street-address"
                          id="form-input-address1"
                          type="text"
                          :state="isEmptyString(form.address1)"
                          :class="needAdditionalPadding(form.address1)"
                        ></b-form-input>
                        <span class="innerlabel" v-if="form.address1"
                          >Street address 1
                        </span>
                        <b-form-invalid-feedback
                          id="form-input-address1"
                          class="pl-3 pt-1"
                        >
                          Street address cannot be empty
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row class="pt-3 pb-2">
                      <b-col cols="12" class="pl-0 pr-0">
                        <b-form-input
                          v-model="form.address2"
                          placeholder="Street Address 2"
                          type="text"
                          :class="needAdditionalPadding(form.address2)"
                        ></b-form-input>
                        <span class="innerlabel" v-if="form.address2"
                          >Street Address 2</span
                        >
                      </b-col>
                    </b-row>
                    <b-row class="pt-3 pb-0" align-h="between">
                      <b-col lg="4" cols="12" class="pl-0 pr-0">
                        <b-row>
                          <b-col class="pl-0 city-state-country">
                            <b-form-input
                              id="form-input-city"
                              v-model="form.city"
                              autocomplete="shipping locality"
                              placeholder="City (*)"
                              :class="needAdditionalPadding(form.city)"
                              :state="isEmptyString(form.city)"
                              type="text"
                            ></b-form-input>
                            <span class="innerlabel" v-if="form.city"
                              >City</span
                            >
                            <b-form-invalid-feedback
                              id="form-input-city"
                              class="pl-3 pt-1"
                            >
                              City cannot be empty
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                      </b-col>

                      <b-col lg="4" cols="12" class="pl-0 pr-0">
                        <b-row>
                          <b-col class="city-state-country">
                            <b-form-group>
                              <b-form-select
                                v-model="form.state"
                                type="text"
                                :options="getUSStatesOptions()"
                                required
                                autocomplete="shipping region"
                                name="state"
                                class="select-special"
                                :class="needAdditionalPadding(form.state)"
                                v-if="form.country == 'US'"
                              ></b-form-select>
                              <b-form-select
                                v-model="form.state"
                                type="text"
                                :options="getCAStatesOptions()"
                                required
                                autocomplete="shipping region"
                                name="state"
                                class="select-special"
                                :class="needAdditionalPadding(form.state)"
                                v-else-if="form.country == 'CA'"
                              ></b-form-select>
                              <b-form-select
                                v-model="form.state"
                                type="text"
                                :options="getAUStatesOptions()"
                                required
                                autocomplete="shipping region"
                                name="state"
                                class="select-special"
                                :class="needAdditionalPadding(form.state)"
                                v-else-if="form.country == 'AU'"
                              ></b-form-select>

                              <b-form-input
                                id="form-input-state"
                                v-model="form.state"
                                placeholder="State/Province (*)"
                                type="text"
                                autocomplete="shipping region"
                                :class="needAdditionalPadding(form.state)"
                                :state="isEmptyString(form.state)"
                                v-else
                              ></b-form-input>
                              <span
                                class="innerlabel pl-3 reduced_pl_pr"
                                v-if="form.state && form.country == 'US'"
                                >State</span
                              >
                              <span
                                class="innerlabel pl-3 reduced_pl_pr"
                                v-if="form.state && form.country != 'US'"
                                >State / Province</span
                              >
                            </b-form-group>

                            <b-form-invalid-feedback
                              id="form-input-state"
                              class="pl-3 pt-1"
                            >
                              State cannot be empty
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                      </b-col>

                      <b-col lg="4" cols="12" class="pl-0 pr-0">
                        <b-row>
                          <b-col class="pr-0 city-state-country">
                            <b-form-input
                              id="form-input-zip"
                              v-model="form.zipcode"
                              placeholder="Zipcode(*)"
                              autocomplete="shipping postal-code"
                              :class="needAdditionalPadding(form.zipcode)"
                              :state="isZipCodeValid(form.zipcode)"
                              type="text"
                            ></b-form-input>
                            <span
                              class="innerlabel pl-3 reduced_pl_pr"
                              v-if="form.zipcode && form.country != 'US'"
                              >Zip code / Postal code</span
                            >
                            <span
                              class="innerlabel pl-3 reduced_pl_pr"
                              v-if="form.zipcode && form.country == 'US'"
                              >Zip code</span
                            >
                            <b-form-invalid-feedback
                              id="form-input-zip"
                              class="pl-3 pt-1"
                            >
                              Zipcode is incorrect
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row v-if="form.country != 'US' && getKioskID() == null">
                      <b-col class="pl-0 pr-0"> Ship from United States </b-col>
                    </b-row>
                    <b-row v-if="form.country == 'US' && getKioskID() == null">
                      <b-col class="pl-0 pr-0">
                        Free US shipping for $50 order or above.
                      </b-col>
                    </b-row>
                    <b-row v-if="getKioskID() == null">
                      <b-col md="6" cols="12" class="pl-0 pr-0 pt-3">
                        <b-row>
                          <b-col
                            class="shipping-selector"
                            style="margin-right: 15px; cursor: pointer"
                            :class="isShippingSelected(0)"
                            @click="selectShipping(0)"
                          >
                            <b-row>
                              <b-col>
                                {{ shippingDisplay(0, 0) }}
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col>
                                {{ shippingDisplay(0, 1) }}
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="6" cols="12" class="pl-0 pr-0 pt-3">
                        <b-row>
                          <b-col
                            class="shipping-selector"
                            style="margin-left: 15px; cursor: pointer"
                            :class="isShippingSelected(1)"
                            @click="selectShipping(1)"
                          >
                            <b-row>
                              <b-col>
                                {{ shippingDisplay(1, 0) }}
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col>
                                {{ shippingDisplay(1, 1) }}
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col
                    lg="4"
                    cols="12"
                    class="pt-4"
                    v-if="getKioskID() == null"
                  >
                    <b-row class="pb-2">
                      <b>Please note:</b>
                    </b-row>
                    <b-row>
                      <ul>
                        <li>
                          We strongly suggest you provide a phone number when
                          shipping internationally.
                        </li>
                        <li>
                          We might use your phone number to provide update on
                          shipping and delivery tracking.
                        </li>
                        <li style="padding-top: 5px">
                          We will use your email address for order confirmation.
                        </li>
                      </ul>
                    </b-row>
                  </b-col>
                </b-row>

                <b-row class="pt-4">
                  <b style="font-size: 24px; padding-left: 0px" class="h2-font"
                    >Enter your contact information</b
                  >
                </b-row>
                <b-row>
                  <b-col md="8" cols="12" class="pl-0 pr-0">
                    <b-row class="pt-3 pb-2">
                      <b-col cols="12" class="pl-0 pr-0">
                        <b-form-input
                          v-model="form.email"
                          id="form-input-email"
                          placeholder="Email (*)"
                          autocomplete="email"
                          :state="isEmptyString(form.email)"
                          type="email"
                          :class="needAdditionalPadding(form.email)"
                        ></b-form-input>
                        <span class="innerlabel" v-if="form.email">Email</span>
                        <b-form-invalid-feedback
                          id="form-input-email"
                          class="pl-3 pt-1"
                        >
                          Please enter correct email address
                        </b-form-invalid-feedback>
                      </b-col>
                    </b-row>
                    <b-row class="pt-3 pb-2">
                      <b-col cols="12" class="pl-0 pr-0">
                        <b-form-input
                          v-model="form.phone"
                          id="form-input-phone"
                          autocomplete="tel"
                          placeholder="Phone number"
                          :state="ifValidPhone(form.phone)"
                          type="tel"
                          :class="needAdditionalPadding(form.phone)"
                        ></b-form-input>
                        <span class="innerlabel" v-if="form.phone">Phone</span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="pt-4" hidden>
                  <b style="font-size: 24px; padding-left: 7px" class="h2-font"
                    >是否需要开具发票</b
                  >
                </b-row>
                <b-row hidden>
                  <b-col md="8" cols="12" class="pl-0 pr-0">
                    <b-row class="pt-3 pb-2">
                      <b-col
                        cols="12"
                        class="ml-0 product-select-box fapiao"
                        style="
                          margin-right: 400px !important;
                          line-height: 60px;
                          cursor: pointer;
                          font-size: 16px;
                          color: #33383a;
                        "
                        :class="getFapiaoClass(0)"
                        @click="form.fapiao = 0"
                      >
                        无需发票
                      </b-col>
                    </b-row>

                    <b-row class="pt-3 pb-2">
                      <b-col
                        cols="12"
                        class="ml-0 product-select-box fapiao"
                        style="
                          margin-right: 400px !important;
                          line-height: 60px;
                          cursor: pointer;
                          font-size: 16px;
                          color: #33383a;
                        "
                        :class="getFapiaoClass(1)"
                        @click="form.fapiao = 1"
                      >
                        普通发票 (我们会与您联系)
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>

                <b-row class="pb-5">
                  <b-col
                    cols="12"
                    style="
                      text-align: left;
                      padding-top: 25px;
                      padding-bottom: 15px;
                    "
                    class="pl-0 pr-0"
                  >
                    <b-button pill type="submit" class="full-width blue-button">
                      <span class="">Continue</span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-form>
          </b-row>

          <b-row v-if="state == 2">
            <b-form style="width: 100%" @submit="onSubmit2">
              <b-col class="pl-0 pr-0">
                <b-row>
                  <b style="font-size: 24px; padding-left: 0px" class="h2-font"
                    >Credit or Debit Cards</b
                  >
                </b-row>

                <b-row class="pt-2">
                  <b-col
                    cols="1"
                    style="min-width: 55px"
                    class="pl-0 pr-0 pt-2"
                  >
                    <b-img src="img/visa@2x.png" style="width: 50px"></b-img>
                  </b-col>
                  <b-col
                    cols="1"
                    style="min-width: 55px"
                    class="pl-0 pr-0 pt-2"
                  >
                    <b-img
                      src="img/master-card@2x.png"
                      style="width: 55px"
                    ></b-img>
                  </b-col>
                  <b-col
                    cols="1"
                    style="min-width: 55px"
                    class="pl-0 pr-0 pt-2"
                  >
                    <b-img
                      src="img/discover@2x.png"
                      style="width: 50px"
                    ></b-img>
                  </b-col>
                  <b-col
                    cols="1"
                    style="min-width: 55px"
                    class="pl-0 pr-0 pt-2"
                  >
                    <b-img
                      src="img/american-express@2x.png"
                      style="width: 50px"
                    ></b-img>
                  </b-col>
                  <b-col
                    cols="1"
                    style="min-width: 55px"
                    class="pl-0 pr-0 pt-2"
                  >
                    <b-img src="img/jcb@2x.png" style="width: 50px"></b-img>
                  </b-col>
                  <b-col
                    cols="1"
                    style="min-width: 60px"
                    class="pl-0 pr-0 pt-2"
                  >
                    <b-img src="img/unionPay.png" style="width: 45px"></b-img>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="8" cols="12" class="pl-0 pr-0">
                    <b-row class="pt-4 pb-0" align-h="between">
                      <b-col lg="12" cols="12" class="pl-0 pr-0 pb-3">
                        <b-row>
                          <b-col class="pl-0 pr-0">
                            <b-form-input
                              v-model="form.cardnum"
                              autocomplete="cc-number"
                              placeholder="Credit Card Number (*)"
                              id="form-input-cardnum"
                              type="number"
                              pattern="[0-9]*"
                              inputmode="numeric"
                              :state="
                                ifValidNum(form.cardnum, 15) ||
                                ifValidNum(form.cardnum, 16)
                              "
                              :class="needAdditionalPadding(form.cardnum)"
                            ></b-form-input>
                            <span class="innerlabel" v-if="form.cardnum"
                              >Card Number</span
                            >
                            <b-form-invalid-feedback
                              id="form-input-cardnum"
                              class="pl-3 pt-1"
                            >
                              Credit card number must be of 15 or 16 digits
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                      </b-col>

                      <b-col lg="4" cols="12" class="pl-0 pr-0">
                        <b-row>
                          <b-col class="city-state-country2 pl-0">
                            <b-form-select
                              v-model="form.cardexpmonth"
                              placeholder="Month"
                              id="form-input-month"
                              :options="months"
                              :state="isEmptyString(form.cardexpmonth)"
                              :class="needAdditionalPadding(form.cardexpmonth)"
                              class="select-special"
                            ></b-form-select>
                            <span
                              class="innerlabel reduced_pl_pr"
                              v-if="form.cardexpmonth"
                              >Month</span
                            >
                            <b-form-invalid-feedback
                              id="form-input-month"
                              class="pl-3 pt-1"
                            >
                              Empty Month
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                      </b-col>

                      <b-col lg="4" cols="12" class="pl-0 pr-0">
                        <b-row>
                          <b-col class="city-state-country2">
                            <b-form-select
                              v-model="form.cardexpyear"
                              placeholder="Year"
                              id="form-input-month"
                              :options="years"
                              :state="isEmptyString(form.cardexpyear)"
                              :class="needAdditionalPadding(form.cardexpyear)"
                              class="select-special"
                            ></b-form-select>
                            <span
                              class="innerlabel pl-3 reduced_pl_pr"
                              v-if="form.cardexpyear"
                              >Year</span
                            >
                            <b-form-invalid-feedback
                              id="form-input-month"
                              class="pl-3 pt-1"
                            >
                              Empty Year
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                      </b-col>

                      <b-col lg="4" cols="12" class="pl-0 pr-0">
                        <b-row>
                          <b-col class="city-state-country2 pr-0">
                            <b-form-input
                              v-model="form.cardcvv"
                              placeholder="CVV (*)"
                              autocomplete="cc-csc"
                              id="form-input-cvv"
                              type="number"
                              pattern="[0-9]*"
                              inputmode="numeric"
                              :state="
                                ifValidNum(form.cardcvv, 3) ||
                                ifValidNum(form.cardcvv, 4)
                              "
                              :class="needAdditionalPadding(form.cardcvv)"
                            ></b-form-input>
                            <span
                              class="innerlabel pl-3 reduced_pl_pr"
                              v-if="form.cardcvv"
                              >CVV</span
                            >
                            <b-form-invalid-feedback
                              id="form-input-cvv"
                              class="pl-3 pt-1"
                            >
                              CVV must be 3 or 4 digits
                            </b-form-invalid-feedback>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>

                    <b-row class="pl-0 pr-0 reduced_pl_pr" v-if="state == 2">
                      <hr
                        style="
                          width: 100%;
                          border: 0.5px solid #d9dadb;
                          margin-left: 0;
                        "
                      />
                    </b-row>

                    <b-row class="pb-0" v-if="state == 2">
                      <b-col
                        md="7"
                        cols="7"
                        class="reduced_pl_pr"
                        style="font-size: 16px"
                      >
                        Subtotal
                      </b-col>
                      <b-col
                        class="reduced_pl_pr"
                        md="5"
                        cols="5"
                        style="font-size: 16px; text-align: right"
                        >${{ getdiscountedtotalprice(true, true) }}</b-col
                      >
                    </b-row>
                    <b-row class="pt-2">
                      <b-col
                        cols="7"
                        class="reduced_pl_pr"
                        style="font-size: 16px"
                      >
                        <b-row> {{ shippingDisplay(form.shipping, 0) }} </b-row>
                        <b-row hidden> Ship from United States </b-row>
                      </b-col>

                      <b-col
                        class="reduced_pl_pr"
                        style="font-size: 16px; text-align: right"
                        >{{ shippingDisplay(form.shipping, 1) }}</b-col
                      >
                    </b-row>

                    <b-row
                      class="pt-2"
                      v-if="state == 2 && form.country != 'US'"
                    >
                      <b-col
                        cols="7"
                        class="reduced_pl_pr"
                        style="font-size: 16px"
                      >
                        <b-row> Sales Tax </b-row>
                      </b-col>

                      <b-col
                        class="reduced_pl_pr"
                        style="font-size: 16px; text-align: right"
                        >$0.00</b-col
                      >
                    </b-row>
                    <b-row class="pt-2" v-else>
                      <b-col
                        cols="7"
                        class="reduced_pl_pr"
                        style="font-size: 16px"
                      >
                        <b-row> Sales Tax </b-row>
                      </b-col>

                      <b-col
                        class="reduced_pl_pr"
                        style="font-size: 16px; text-align: right"
                        >${{ estimatetax(form.state) }}</b-col
                      >
                    </b-row>

                    <b-row class="pl-0 pr-0 reduced_pl_pr" v-if="state == 2">
                      <hr
                        style="
                          width: 100%;
                          border: 0.5px solid #d9dadb;
                          margin-left: 0;
                        "
                      />
                    </b-row>

                    <b-row v-if="paymenterror != null && paymenterror != ''">
                      <b-col class="pl-0 pt-1" style="color: red">
                        {{ paymenterror }}
                      </b-col>
                    </b-row>

                    <b-row class="pb-2">
                      <b-col
                        cols="12"
                        style="text-align: left; padding-top: 10px"
                        class="pl-0 pr-0"
                      >
                        <b-button
                          pill
                          type="submit"
                          class="full-width blue-button"
                        >
                          <span class="">Review Order</span>
                        </b-button>
                      </b-col>
                    </b-row>
                    <b-row style="padding-bottom: 300px">
                      <b-col class="pl-0 pr-0 pt-4">
                        <ul style="padding-left: 20px">
                          <li>Secure checkout.</li>
                          <li>
                            We accept Visa, Mastercard, American Express,
                            Discover, JCB Diners Club, China UnionPay.
                          </li>
                          <li>
                            Your payment card is immediately tokenized. Card
                            number is not stored on our server.
                          </li>

                          <li>
                            <b>
                              Order summary page will be displayed on the next
                              page for your review before final order
                              submission.
                            </b>
                          </li>
                        </ul>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-form>
          </b-row>

          <b-row v-if="state == 3">
            <b-col class="pl-0 pr-0">
              <b-row class="pl-3 pr-3 reduced_pl_pr" v-if="state != 3">
                <hr
                  style="
                    width: 100%;
                    border: 0.5px solid #d9dadb;
                    margin-left: 0;
                  "
                />
              </b-row>
              <b-row class="pl-3 pr-3 pt-3 reduced_pl_pr">
                <b-col
                  md="3"
                  cols="12"
                  class="reduced_pl_pr more-bottom-padding-small"
                >
                  <b-row
                    style="font-size: 24px"
                    class="pb-2 h2-font"
                    v-if="getKioskID() == null"
                  >
                    Shipping Details
                  </b-row>
                  <b-row>
                    <a href="#" @click="gotostate(1)">Edit</a>
                  </b-row>
                </b-col>
                <b-col
                  md="5"
                  cols="12"
                  class="pl-1 reduced_pl_pr more-bottom-padding-small"
                >
                  <b-row class="pb-2">
                    <b style="font-size: 16px" v-if="getKioskID() == null"
                      >Delivery Address:</b
                    >
                    <b style="font-size: 16px" v-else>Billing Address:</b>
                  </b-row>
                  <b-row class="pb-2" style="font-size: 16px">
                    {{ form.lname + " " + form.fname }}
                  </b-row>
                  <b-row class="pb-2" style="font-size: 16px">
                    {{ form.address1 }}
                  </b-row>
                  <b-row
                    v-if="form.address2 != null && form.address2 != ''"
                    class="pb-2"
                    style="font-size: 16px"
                  >
                    {{ form.address2 }}
                  </b-row>

                  <b-row class="pb-2" style="font-size: 16px">
                    {{ form.city }}, {{ form.state }}, {{ form.zipcode }},
                  </b-row>
                  <b-row class="pb-2" style="font-size: 16px">
                    {{ getFullCountry(form.country) }}
                  </b-row>
                </b-col>

                <b-col md="4" cols="12" class="reduced_pl_pr">
                  <b-row class="pb-2">
                    <b style="font-size: 16px">Contact:</b>
                  </b-row>
                  <b-row class="pb-2" style="font-size: 16px">
                    Email: {{ form.email }}
                  </b-row>
                  <b-row class="pb-2" style="font-size: 16px">
                    Tel: {{ form.phone }}
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pl-3 pr-3 reduced_pl_pr">
                <hr
                  style="
                    width: 100%;
                    border: 0.5px solid #d9dadb;
                    margin-left: 0;
                  "
                />
              </b-row>
              <b-row class="pl-3 pr-3 reduced_pl_pr">
                <b-col
                  md="3"
                  cols="12"
                  align-self="center"
                  class="reduced_pl_pr"
                >
                  <b-row style="font-size: 24px" class="pb-2 h2-font">
                    Payment Details
                  </b-row>
                  <b-row>
                    <a href="#" @click="gotostate(2)">Edit</a>
                  </b-row>
                </b-col>
                <b-col md="9" cols="12" class="pl-0 reduced_pl_pr">
                  <b-row>
                    <b-col
                      cols="12"
                      class="pt-3 pb-3 pl-1 reduced_pl_pr"
                      style="font-size: 16px"
                    >
                      <b-img :src="getCardStock()" style="width: 52px"></b-img>

                      &nbsp; Card ending in
                      {{ this.token.data.card.last4 }} &nbsp; &nbsp; Exp:
                      {{ this.token.data.card.exp_month }}/{{
                        this.token.data.card.exp_year
                      }}
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="pl-3 pr-3 reduced_pl_pr" v-if="state == 3">
                <hr
                  style="
                    width: 100%;
                    border: 0.5px solid #d9dadb;
                    margin-left: 0;
                  "
                />
              </b-row>

              <b-row class="pb-2" v-if="state == 3">
                <b-col cols="3" class="hide-when-small"></b-col>
                <b-col cols="7" class="reduced_pl_pr" style="font-size: 18px">
                  {{ getshipping(0) }}
                </b-col>
                <b-col
                  class="reduced_pl_pr"
                  style="font-size: 18px; text-align: right"
                  >{{ getshipping(1) }}</b-col
                >
              </b-row>
              <b-row class="pb-2" v-if="state == 3">
                <b-col cols="3" class="hide-when-small"></b-col>
                <b-col cols="7" class="reduced_pl_pr" style="font-size: 18px">
                  {{ gettax(0) }}
                </b-col>
                <b-col
                  class="reduced_pl_pr"
                  style="font-size: 18px; text-align: right"
                  >{{ gettax(1) }}</b-col
                >
              </b-row>
              <b-row v-if="state == 3" class="pb-5">
                <b-col cols="12" class="pl-0 pr-0">
                  <b-row
                    class="pb-2"
                    v-if="
                      getdiscountedtotalprice(false, false) -
                        getdiscountedtotalprice(true, true) >
                      0.1
                    "
                  >
                    <b-col cols="3" class="hide-when-small"></b-col>
                    <b-col
                      cols="7"
                      class="reduced_pl_pr"
                      style="font-size: 18px"
                    >
                      Discount
                    </b-col>
                    <b-col
                      class="reduced_pl_pr"
                      style="text-align: right; font-size: 18px"
                    >
                      $-{{
                        (
                          getdiscountedtotalprice(false, false) -
                          getdiscountedtotalprice(true, true)
                        ).toFixed(2)
                      }}
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="3" class="hide-when-small"></b-col>
                    <b-col
                      cols="7"
                      class="reduced_pl_pr"
                      style="font-size: 20px"
                    >
                      <b style="font-size: 20px" class="h2-font">Total</b>
                    </b-col>
                    <b-col class="reduced_pl_pr" style="text-align: right">
                      <b style="font-size: 20px" class="h2-font"
                        >${{ (order.data.amount / 100).toFixed(2) }}</b
                      >
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" class="reduced_pl_pr">
                  <hr style="width: 100%; border: 0.5px solid #d9dadb" />
                </b-col>
                <b-col
                  cols="12"
                  class="reduced_pl_pr"
                  v-if="getKioskID() != null"
                >
                  <u>This checkout is for Kiosk Pickup self-service only.</u> If
                  you want this order shipped to you, please close this browser
                  window, open a new window and place a new order.
                </b-col>
                <b-col
                  md="12"
                  class="pl-0 pt-1"
                  style="color: red; text-align: right"
                  v-if="paymenterror2 != null && paymenterror2 != ''"
                >
                  {{ paymenterror2 }}
                </b-col>
                <b-col
                  md="12"
                  cols="12"
                  class="reduced_pl_pr"
                  style="
                    text-align: right;
                    padding-top: 25px;
                    padding-bottom: 15px;
                  "
                >
                  <b-button
                    pill
                    class="full-width blue-button"
                    v-on:click="handleClickFinalize()"
                  >
                    <span class="">Place Order</span>
                  </b-button>
                </b-col>
                <b-col
                  md="12"
                  cols="12"
                  class="reduced_pl_pr align-center-small"
                  align-self="center"
                  style="text-align: right"
                >
                  By clicking "Place Order", you agree to Truthbrush's
                  <a href="/#/tc"> Terms of Services </a> and
                  <a href="/#/privacy"> Privacy Policy</a>.
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row align-h="center" style="width: 100%">
        <b-col cols="12" class="cart-nav"></b-col>
      </b-row>

      <b-row style="width: 100%">
        <nav-footer></nav-footer>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import storage from "../storage";
import store from "../store";
import env from "./../env";
import {
  submitNewOrder,
  submitOrderInfo,
  tokenize,
  captureOrder,
} from "../api/store";
import DropdownMenu from "@innologica/vue-dropdown-menu";
export default {
  name: "Cart",
  components: {
    NavHeader,
    NavFooter,
    DropdownMenu,
  },
  data() {
    return {
      show: false,
      opencloselist: [],
      firstTime: true,
      show_pay_in_4: true,
      order: {
        data: {
          amount: 0,
        },
      },
      form: {
        fname: null,
        lname: null,
        address1: null,
        address2: null,
        selectedcity: [],
        state: "Alabama",
        country: "US",
        zipcode: null,
        receiverphone: null,
        email: null,
        phone: null,
        fapiao: 0,
        payment: 1,
        cardnum: "",
        cardexpmonth: "01",
        cardexpyear: "2023",
        cardcvv: null,
        shipping: 0,
      },

      stripe: null,
      redirectmessage: "",
      paymenterror: "",
      paymenterror2: "234",
      statustimer: 0,
      interval: null,
      productname: "",
      producttitle: "Your Order",
      state: 0,
      breadcrumbitems: [
        [
          {
            text: "购买",
            href: "/#/select",
          },
          {
            text: "购物袋",
            href: "/#/cart",
            active: true,
          },
        ],
        [
          {
            text: "购买",
            href: "/#/select",
          },
          {
            text: "购物袋",
            href: "javascript:onGogoCart()",
            active: false,
          },
          {
            text: "送货地址",
            href: "#",
            active: true,
          },
        ],
      ],
      optionsQuantity: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23,
      ],
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      years: [
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
        "2041",
        "2042",
        "2043",
        "2044",
        "2045",
        "2046",
        "2047",
        "2048",
        "2049",
        "2050",
        "2051",
        "2052",
      ],
    };
  },
  methods: {
    getFullCountry(key) {
      for (var i = 0; i < this.$store.state.countries.length; i++) {
        if (this.$store.state.countries[i].value == key) {
          return this.$store.state.countries[i].text;
        }
      }
      return key;
    },
    getselectedsku() {
      var list = [];
      if (
        store.state.skuquantitylist != null &&
        store.state.skuquantitylist.selectedsku != null
      ) {
        return store.state.skuquantitylist.selectedsku;
      }

      return list;
    },
    detectMob() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
      ];
      return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
      });
    },
    visit(url) {
      window.location.href = url;
    },

    getdiscountedtotalprice(bundle, coupon) {
      return storage.calculateBundleDiscount(bundle, coupon);
    },
    speelplural(q, word) {
      if (q <= 1) {
        return word;
      } else {
        return word + "s";
      }
    },
    getCountryOptions() {
      return this.$store.state.countries;
    },
    getUSStatesOptions() {
      return this.$store.state.statesusa;
    },
    getAUStatesOptions() {
      return this.$store.state.statesaustralia;
    },
    getCAStatesOptions() {
      return this.$store.state.statescanada;
    },
    changecountry() {
      //console.log(this.form.country);
      if (this.form.country == "US") {
        this.form.state = "Alabama";
      } else if (this.form.country == "CA") {
        this.form.state = "Alberta";
      } else if (this.form.country == "AU") {
        this.form.state = "New South Wales";
      } else {
        this.form.state = null;
      }
    },
    isShippingSelected(index) {
      //console.log(index+ " "+this.form.shipping )
      if (this.form.shipping == index) {
        return "shipping-selector-on";
      }
    },
    selectShipping(index) {
      if (index == 0) {
        this.form.shipping = 0;
      } else {
        this.form.shipping = 1;
      }
    },
    shippingDisplay(isstandard, top) {
      if (isstandard == 0) {
        // standardshipping
        if (top == 0) {
          if (this.getKioskID() != null) {
            return "Shipping (Kiosk Pickup)";
          }
          if (this.form.country == "US") {
            return "Standard (5-7 business days)";
          } else {
            return "Standard (7-14 business days)";
          }
        } else {
          return "$" + this.estimateshipping(false).toFixed(2);
        }
      } else {
        // express shipping
        if (top == 0) {
          if (this.form.country == "US") {
            return "Express (2 business days)";
          } else {
            return "Express (2-5 business days)";
          }
        } else {
          return "$" + this.estimateshipping(true).toFixed(2);
        }
      }
    },
    getshipping(index) {
      var selectedrate = this.order.data.selectedShippingMethod;
      var obj = null;
      for (var i = 0; i < this.order.data.shippingMethods.length; i++) {
        if (this.order.data.shippingMethods[i].id == selectedrate) {
          obj = this.order.data.shippingMethods[i];
        }
      }
      if (obj != null) {
        if (index == 0) {
          if (this.getKioskID() != null) {
            return "Kiosk Pickup";
          }
          if (this.form.country == "US") {
            return obj.description;
          } else {
            return obj.description;
          }
        } else {
          return "$" + (obj.amount / 100.0).toFixed(2);
        }
      }
      return "";
    },

    gettax(index) {
      var obj = null;
      for (var i = 0; i < this.order.data.items.length; i++) {
        if (this.order.data.items[i].type.includes("tax")) {
          obj = this.order.data.items[i];
        }
      }
      if (obj != null) {
        if (index == 0) {
          return obj.description;
        } else {
          return "$" + (obj.amount / 100.0).toFixed(2);
        }
      }
      return "";
    },

    typingPhone() {
      this.form.senderphone = this.form.receiverphone;
    },
    isValidEmail(email) {
      if (email == null) return email;
      if (email == "") return true;
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    isEmptyString(index) {
      if (index == null) return index;
      if (index.trim() == "") {
        return false;
      }
      return true;
    },
    isZipCodeValid(zipcode) {
      if (zipcode == null) return zipcode;
      if (zipcode.trim() == "") {
        return false;
      }

      if (this.form.country == "US") {
        if (zipcode.includes("-")) {
          return false;
        }
        if (zipcode.trim().length != 5) {
          return false;
        }
        let isnum = /^\d+$/.test(zipcode);
        if (!isnum) return false;
      }
      return true;
    },
    ifValidNum(phone, len) {
      if (phone == null) return null;
      phone = phone.trim();
      if (phone.trim().length != len) {
        return false;
      }

      let isnum = /^\d+$/.test(phone);
      return isnum;
    },
    getCardStock() {
      if (this.token.data.card.brand == "MasterCard") {
        return "img/master-card@2x.png";
      } else if (this.token.data.card.brand == "Visa") {
        return "img/visa@2x.png";
      } else if (this.token.data.card.brand == "American Express") {
        return "img/american-express@2x.png";
      } else if (this.token.data.card.brand == "Diners Club") {
        return "img/master-card@2x.png";
      } else if (this.token.data.card.brand == "Discover") {
        return "img/discover@2x.png";
      } else if (this.token.data.card.brand == "JCB") {
        return "img/jcb@2x.png";
      } else if (this.token.data.card.brand == "UnionPay") {
        return "img/unionPay.png";
      }
    },
    ifValidPhone(phone) {
      if (phone == null) return null;
      if (phone.trim().length >= 0) {
        return true;
      }
      return false;
    },
    getPaymentClass(index) {
      if (this.form.payment == index) {
        return "product-select-box2";
      }
    },
    getFapiaoClass(index) {
      if (this.form.fapiao == index) {
        return "product-select-box2";
      }
    },
    needAdditionalPadding(str) {
      if (str == null || str == "") {
        return "nopadding";
      } else {
        return "additionalPadding";
      }
    },
    onSubmit2(event) {
      event.preventDefault();

      if (
        this.form.cardnum == null ||
        (!this.ifValidNum(this.form.cardnum, 15) &&
          !this.ifValidNum(this.form.cardnum, 16))
      ) {
        this.form.cardnum = "";
        return;
      }

      if (
        this.form.cardcvv == null ||
        (!this.ifValidNum(this.form.cardcvv, 3) &&
          !this.ifValidNum(this.form.cardcvv, 4))
      ) {
        this.form.cardcvv = "";
        return;
      }
      this.show = true;
      var _data =
        "card[number]=" +
        this.form.cardnum +
        "&" +
        "card[exp_month]=" +
        parseInt(this.form.cardexpmonth) +
        "&" +
        "card[exp_year]=" +
        parseInt(this.form.cardexpyear) +
        "&" +
        "card[cvc]=" +
        this.form.cardcvv;
      var context = this;
      context.show = true;
      context.paymenterror = "";
      tokenize(_data)
        .then((res) => {
          context.token = res;
          storage.reportAddPayment();
          submitNewOrder(this.constructOrderObject())
            .then((res) => {
              //console.log(res);
              context.show = false;
              context.order = res;
              context.showshippingform = false;
              context.showpaymentform = false;
              context.state = 3;
              context.paymenterror2 = "";
            })
            .catch(function (err) {
              alert(err);
              context.ordererror = "something wrong with order";
              context.show = false;
            });
        })
        .catch(function (err) {
          context.show = false;
          context.paymenterror = err.response.data.error.message;
          context.token = null;
        });
    },
    handleClickFinalize() {
      var context = this;
      context.show = true;
      captureOrder(this.order.data.id, this.token.data.id)
        .then(function () {
          context.show = false;
          storage.clearCart();
          context.$store.orderpaid = context.order;
          context.$store.orderform = context.form;
          context.$store.ordertoken = context.token;

          /* report orderinfo */
          var orderinfo = {};
          orderinfo.orderid = context.order.data.id;
          orderinfo.coupon = storage.getCoupon();
          orderinfo.ordertype = "stripe";
          orderinfo.email = context.order.data.email;
          orderinfo.shipping = JSON.stringify(context.order.data.shipping);
          orderinfo.description = JSON.stringify(context.order.data.items);
          orderinfo.orderprice = context.order.data.amount;

          try {
            var shipping = context.order.data.shipping;
            var fn = shipping.name.split(" ")[0];
            var ln = shipping.name.split(" ")[1];

            storage.initExtended(
              context.order.data.email,
              fn,
              ln,
              shipping.phone,
              shipping.address.city,
              shipping.address.state,
              shipping.address.postal_code,
              shipping.address.country
            );
          } catch (e) {
            console.log();
          }
          storage.reportPurchase(orderinfo.orderprice / 100.0);

          submitOrderInfo(orderinfo)
            .then(() => {
              //console.log("order info ok:" + res);
            })
            .catch(function () {
              //console.log("order info failed:" + err);
            });

          window.location.href = "/#/confirm";
        })
        .catch(function (err) {
          //console.log(JSON.stringify(err));
          context.paymenterror2 =
            "Please check card number, expiry and cvv info entered. " + err.response.data;
          context.show = false;
        });
    },
    constructOrderObject() {
      var object = {};
      object.line1 = this.form.address1;
      if (this.form.address2 != null && this.form.address2 != "") {
        object.line2 = this.form.address2;
      }
      object.city = this.form.city;
      object.state = this.form.state;
      object.country = this.form.country;
      object.postal_code = this.form.zipcode;
      object.email = this.form.email;
      object.name = this.form.fname + " " + this.form.lname;
      object.phone = this.form.phone;
      if (this.form.shipping == 0) {
        object.selected_shipping_method = "standard";
      } else {
        object.selected_shipping_method = "express";
      }
      var singleskus = {};
      for (var i = 0; i < store.state.skuquantitylist.selectedsku.length; i++) {
        singleskus[store.state.skuquantitylist.selectedsku[i].sku.id] =
          store.state.skuquantitylist.selectedsku[i].quantity;
      }

      if (this.getKioskID() != null) {
        singleskus["sku_kiosk_free_shipping"] = 1;
      }
      object.singleskus = singleskus;
      if (store.state.couponid != null) {
        object.coupon = store.state.couponid;
      }
      return object;
    },
    estimateshipping(isExpress) {
      var cart = storage.calculatetotalprice(
        store.state.skuquantitylist.selectedsku
      );
      var total = storage.calculateBundleDiscount(true, true);
      if (this.form.country == "US") {
        return storage.calculateShippingByQuantity(cart[4], total, isExpress);
      } else {
        return storage.calculateShippingByQuantity_International(
          cart[4],
          this.form.country,
          isExpress
        );
      }
    },
    estimatetax(state) {
      var total = storage.calculateBundleDiscount(true, true);
      //console.log("total is:"+total)
      if (this.form.country == "US") {
        return storage.calculatetax(state, total);
      } else {
        return 0;
      }
    },
    onSubmit(event) {
      event.preventDefault();
      if (
        this.isEmptyString(this.form.lname) &&
        this.isEmptyString(this.form.fname) &&
        this.isEmptyString(this.form.address1) &&
        this.isEmptyString(this.form.city) &&
        this.isEmptyString(this.form.state) &&
        this.isEmptyString(this.form.email) &&
        this.ifValidPhone(this.form.country) &&
        this.isZipCodeValid(this.form.zipcode)
      ) {
        this.state = 2;
        this.show = true;
        var context = this;
        window.scrollTo(0, 0);
        setTimeout(function () {
          context.show = false;
        }, 500);
      } else {
        window.scrollTo(0, 0);
        return;
      }
      //alert(JSON.stringify(this.form))
    },
    clearCart() {
      storage.clearCart();
      window.location.href = "/#/select";
    },
    gotostate(index) {
      if (index == 1) {
        storage.reportInitCheckout(this.getdiscountedtotalprice());
      }

      this.state = index;
      this.show = true;
      var context = this;
      clearInterval(context.interval);
      context.redirectmessage = "";
      setTimeout(function () {
        context.show = false;

        const element = context.$refs.paypalbutton;
        if (element != null) {
          storage.updatePayPayButton(element, context);
        }

        const elementstripe = context.$refs.stripebutton;
        storage.updateStripeButton(elementstripe, context);
      }, 500);
      window.scrollTo(0, 0);
    },
    getSwatch(sku) {
      return sku.metadata.image0;
    },
    deletesku(sku) {
      storage.deletesku_from_store(sku);
      storage.saveStore2Cart();
      this.getproductname();
      if (store.state.skuquantitylist.selectedsku.length == 0) {
        window.location.href = "/#/select";
      }else{
        this.checkPayPalButton();
      }
    },
    getproductname() {
      return storage.getproductname();
    },
    getKioskID() {
      return storage.getKiosk();
    },
    clickquantity(item, quantity) {
      //console.log(item + " " + quantity);
      item.quantity = quantity;
      storage.saveStore2Cart();
      storage.updatecartlen();
      this.getproductname();
      item.selectquantityopen = false;
      this.opencloselist = [];
      for (var i = 0; i < store.state.skuquantitylist.selectedsku.length; i++) {
        this.opencloselist.push(false);
      }
    },
    checkPayPalButton() {
      var context = this;
      if (storage.is_subscription_item_in_cart()) {
        this.show_pay_in_4 = false;
      } else {
        this.$loadScript("https://www.paypalobjects.com/api/checkout.js").then(
          () => {
            const element = context.$refs.paypalbutton;
            if (element != null) {
              if(element.childElementCount==0){
                storage.updatePayPayButton(element, context);
              }
            }
          }
        );
        this.show_pay_in_4 = true;
      }
    },
  },
  mounted() {
    var context = this;

    var stripekey = env.stripe_public_key;
    this.$loadScript(
      "https://js.stripe.com/v3/" // production
    ).then(() => {
      //console.log("stripe loaded");
      context.stripe = window.Stripe(stripekey, {
        apiVersion: "2020-08-27",
      });

      const elementstripe = context.$refs.stripebutton;
      storage.updateStripeButton(elementstripe, context);
    });

    this.checkPayPalButton();

    storage.processCoupon();
    if (store.state.skuquantitylist.selectedsku.length == 0) {
      window.location.href = "/#/select";
    }
  },
};
</script>

<style lang="scss">
.swatch_small_single_display_skin_cart {
  width: 90% !important;
  height: auto !important;
  padding: 5px !important;
}

@media (max-width: 768px) {
  .padding-top-more-small {
    padding-top: 15px;
  }
  .hide-when-small {
    display: none;
  }

  .align-center-small {
    text-align: center !important;
  }
}
@media (min-width: 769px) {
  .hide-when-big-769 {
    display: none;
  }

  .variable-height-paypal {
    height: 40px !important;
  }
}
.show-top-border {
  border-top: 1px solid #c6e3f7;
}
.no-top-border {
  border-top: none;
}
@media (max-width: 992px) {
  .cartsection > .row > .col-lg-8,
  .cartsection {
    padding-left: 0;
    padding-right: 0;
  }
  .padding-cart-small > .row > .col-lg-8,
  .padding-cart-small {
    padding-left: 0;
    padding-right: 0;
  }
  .padding-cart-small {
    padding-top: 25px;
    padding-bottom: 45px;
  }
}
@media (max-width: 1199px) {
  .left-align-small {
    text-align: left !important;
  }
}
@media (min-width: 1200px) {
}
.whole-border-round {
  border: 1px solid #c6e3f7;
  border-radius: 20px;
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 0;
  padding-right: 0;
}
.cart-title {
  font-size: 14px;
  color: #111111;
}
.product-name {
  font-size: 20px;
  line-height: 32px;
}
.breadcrumb-item a {
  color: #05c5ee;
}
.breadcrumb-item {
  font-size: 14px;
}
.breadcrumb {
  background-color: transparent !important;
  padding-left: 0.5rem;
}
.b-overlay .spinner-border {
  color: #2ebfde !important;
}
.position-absolute {
  position: fixed !important;
}
.cartsection {
  min-height: calc(100vh - 351px);
}

.shipping-selector {
  padding-top: 3px;
  padding-bottom: 3px;
  border: 2px solid #bdbdbd;
  border-radius: 6px;
  .col {
    text-align: center;
    font-size: 16px;
    color: #495057;
  }
}

.shipping-selector-on {
  border: 2px solid #12b8ed !important;
  .col {
    text-align: center;
    font-size: 16px;
    color: black !important;
  }
}

@media (max-width: 1199px) {
  .cart-nav {
    padding: 0.5rem 15px !important;
  }
  .hide-when-small-1200 {
    display: none !important;
  }
}
@media (min-width: 1200px) {
  .cart-nav {
    padding-left: calc(50% - 600px + 45px) !important;
    padding-right: calc(50% - 600px + 45px) !important;
  }
  .hide-when-big-1200 {
    display: none;
  }
}
@media only screen and (min-width: 1440px) {
  .cart-nav {
    padding-left: calc(50% - 720px + 45px) !important;
    padding-right: calc(50% - 720px + 45px) !important;
  }
  .b-nav-dropdown ul {
    display: none !important;
  }
}
a {
  color: #12b8ed;
}
.product-select-box {
  border-radius: 5px;
  border: 4px solid;
  border-color: #bdbdbd;
}
.product-select-box-no-bound {
  border-radius: 5px;
  border: 4px solid;
  border-color: transparent;
}
.product-select-box2 {
  border-radius: 5px;
  border: 4px solid;
  border-color: #12b8ed !important;
}
input,
.area-select,
.select-special {
  height: 60px !important;
  border-radius: 6px !important;
  border: 2px #bdbdbd solid !important;
  border-color: #201f1f;
  font-size: 16px !important;
}
.area-select {
  margin-left: 0 !important;
  width: 33% !important;
}
.area-select span {
  font-size: 18px !important;
  padding-top: 18px !important;
  color: #33383a;
}
.additionalPadding {
  padding-top: 24px;
}
.area-select-wrap {
  width: 100%;
}
.innerlabel {
  position: absolute;
  top: 8px;
  left: 13px;
  font-size: 12px !important;
  color: #33383a;
}

@media (max-width: 992px) {
  .city-state-country2 {
    padding-bottom: 18px;
    padding-left: 0;
    padding-right: 0;
  }
  .reduced_pl_pr {
    padding-left: 0 !important;
  }
  .city-state-country {
    padding-bottom: 18px;
    padding-left: 0;
    padding-right: 0;
    .form-group {
      margin-bottom: 0;
    }
  }
}

@media (max-width: 768px) {
  .shipping-selector {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .variable-height-paypal {
    height: 40px !important;
  }
  .reduced_pl_pr {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .accordion__title {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .h1-font {
    font-size: 28px !important;
    font-weight: 600 !important;
  }
  .h2-font {
    font-size: 24px !important;
    font-weight: 600 !important;
  }
  .h3-font {
    font-size: 20px !important;
    font-weight: 600 !important;
  }
  .h4-font {
    font-size: 16px !important;
  }
  .h5-font {
    font-size: 12px !important;
  }
  .accordion__title-text {
    font-size: 16px !important;
  }
  .image-side-2-side {
    max-height: 200px !important;
    max-width: 50%;
  }
  .swatch_small_single_display {
    width: 80% !important;
    height: auto !important;
  }

  .dropdown-menu {
    min-width: 100% !important;
    text-align: center;
  }
  .more-bottom-padding-small {
    padding-bottom: 15px;
  }
  .area-select {
    margin-bottom: 16px;
    min-width: 100%;
  }
  .full-width {
    width: 100%;
  }
  .no-padding-top-small {
    padding-top: 0 !important;
  }

  .full-width.blue-button,
  .full-width.blue-button-outline {
    width: 100% !important;
    max-width: 100% !important;
  }
}

ul {
  list-style-position: outside;
}

.area-select-option {
  font-size: 18px;
}
.blue-button,
.blue-button:hover {
  background-color: #12b8ed;
  border: none;
  padding: 12px 60px;
}
.blue-button-outline,
.blue-button-outline:hover {
  background-color: transparent;
  border: 1px solid #12b8ed;
  color: #12b8ed;
  padding: 0 60px;
}

.form-group {
  padding-bottom: 0px !important;
}

.full-width.blue-button,
.full-width.blue-button-outline {
  width: 100% !important;
  max-width: 500px !important;
  height: 60px;

  span {
    font-size: 18px;
  }
}

.paypal-buttons {
  width: 100%;
  max-width: 500px !important;
}
</style>